import { writable } from "svelte/store";

export const selectCharacterSceneVisibleStore = writable(false);
